import { motion, useInView } from "framer-motion"
import { Link, graphql, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import { Autoplay, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Swiper, SwiperSlide } from "swiper/react"
import ImageOpt from "./ImageOpt"

const RelatedCards = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  const cardsData = useStaticQuery(graphql`
    query {
      wp {
        fluxDnaSettings {
          fluxDna {
            cards {
              link {
                target
                title
                url
              }
              cardType
              image {
                altText
                mediaItemUrl
                publicUrl
              }
              title
            }
          }
        }
      }
    }
  `)
  const cardsDataList = cardsData.wp.fluxDnaSettings.fluxDna
  const selectCards = module.selectCards
  if (module.hideSection === "no") {
    return (
      <motion.section
        initial="hidden"
        animate={isInView || hasPlayed ? "show" : "hidden"}
        variants={sectionShow}
        className={`discover-card pt-80 pb-60 lgscreen:py-30${
          module.extraClass ? ` ${module.extraClass}` : ""
        }`}
        id={module.extraId}
      >
        <motion.div
          ref={ref}
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className="container-fluid-lg"
        >
          <div className="text-center">
            {module?.heading && (
              <motion.h2 variants={animFade}>{module.heading}</motion.h2>
            )}
            {module?.description && (
              <motion.div variants={animFade} className="content pt-10">
                {parse(module.description)}
              </motion.div>
            )}
          </div>
          <div className="relative mt-60 lgscreen:mt-30">
            <Swiper
              spaceBetween={30}
              slidesPerView={"11"}
              speed={1000}
              pagination={{
                clickable: false,
              }}
              loop={"false"}
              breakpoints={{
                0: {
                  slidesPerView: 1.2,
                  spaceBetween: 15,
                  centeredSlides: true,
                  loop: true,
                },
                641: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
              modules={[Autoplay, Navigation]}
            >
              {cardsDataList.cards
                .concat(cardsDataList.cards)
                .map((item, i) => {
                  if (
                    selectCards.filter(card => card === item.cardType).length >
                    0
                  ) {
                    return (
                      <SwiperSlide key={i}>
                        <motion.div variants={animFade}>
                          <Link
                            to={item.link.url}
                            className="img portrait group"
                            target={item.link.target}
                          >
                            {item?.image && (
                              <>
                                <div className="img-overlay absolute top-0 left-0 h-full w-full z-9 bg-[#000000]/0 group-hover:bg-[#000000]/[0.15] transition-all duration-150 ease-out"></div>
                                <div className="img relative">
                                  <ImageOpt
                                    imgData={item.image.mediaItemUrl}
                                    imgAlt={item.image.altText}
                                    width={1400}
                                    height={1000}
                                    imgLoad="lazy"
                                  />
                                </div>
                              </>
                            )}
                            <div className="absolute top-50per translate-y-minus_50 w-full text-center z-10">
                              <div className="title-white w-full max-w-[240px] mx-auto">
                                {item?.title && (
                                  <motion.h3 variants={animFade}>
                                    {" "}
                                    {item.title}
                                  </motion.h3>
                                )}
                              </div>
                            </div>
                          </Link>
                        </motion.div>
                      </SwiperSlide>
                    )
                  } else {
                    return ""
                  }
                })}
            </Swiper>
          </div>
        </motion.div>
      </motion.section>
    )
  }
  return null
}

export default RelatedCards
export const PageRelatedCardsFragment = graphql`
  fragment PageRelatedCardsFragment on WpPage_Pagecontent_PageContent_RelatedCards {
    extraId
    extraClass
    hideSection
    heading
    description
    selectCards
  }
`
export const PromotionRelatedCardsFragment = graphql`
  fragment PromotionRelatedCardsFragment on WpPromotion_Promotioncontent_PromotionContent_RelatedCards {
    extraId
    extraClass
    hideSection
    heading
    description
    selectCards
  }
`
